<template>
  <div>
    <VueMultiselectComponent
      v-model="localSelected"
      :options="data"
      :placeholder="placeholder"
      class="bg-white rounded"
    />
  </div>
</template>

<script>
import VueMultiselectComponent from "vue-multiselect-component";

export default {
  components: {
    VueMultiselectComponent,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    placeholder: {
      type: String,
      default: "",
    },
    selected: {
      type: Array,
      default: () => [],
    },
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localSelected: this.selected.slice(),
    };
  },
  mounted() {
    const input = this.$el.querySelector(".vue2-editor-input");
    if (input) {
      input.setAttribute("required", true);
    }
  },
  watch: {
    localSelected(newVal) {
      this.$emit("update:selected", newVal);
      if (newVal.length > 0) {
        this.$el
          .querySelector(".vue2-editor-input")
          .removeAttribute("required");
      } else {
        this.$el
          .querySelector(".vue2-editor-input")
          .setAttribute("required", true);
      }
    },
    selected(newVal) {
      this.localSelected = newVal.slice();
    },
    clear() {
      this.localSelected = [];
    },
  },
};
</script>

<style>
*,
::after,
::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Noto Sans Thai", sans-serif !important;
}
.vue2-placeholder {
  z-index: 1 !important;
}
.vue2-multi-select {
  padding: 0.2rem !important;
  display: block !important;
}
.vue2-actions {
  display: none !important;
}
.vue2-value-item {
  background-color: rgba(104, 104, 104, 0.15) !important;
  margin-top: 1px !important;
  .vue2-value-item-text {
    color: #000 !important;
  }
  .vue2-close-icon {
    color: #000 !important;
  }
}
.vue2-multi-select .vue2-value-items {
  width: 100% !important;
}
.vue2-list {
  padding-left: 1rem !important;
}
</style>
